import { RouteObject } from "react-router-dom";
import { ROUTES } from "common/constants/routes";
import Message from "../shared/components/Message";
import ProtectedRoute from "auth/hoc/ProtectedRoute";

import ManageUsers from "manage/users/ManageUsers";
import UserDetailsPage from "manage/users/UserDetailsPage";
import ManageRoles from "manage/roles/ManageRoles";
import ManageApiClients from "manage/api-clients/ManageApiClients";
import ManageCostCodes from "manage/cost-codes/ManageCostCodes";
import ManageCurrencies from "manage/currencies/ManageCurrencies";
import ManageHelixTemplates from "manage/helix-templates/ManageHelixTemplates";
import { READ_HELIX_TEMPLATES_PERMISSION } from "manage/helix-templates/Helix";

import ManagePOTypes from "manage/po-types/ManagePOTypes";
import Notifications from "stories/components/notifications/Notifications";
import ManageTeamsTable from "manage/teams/ManageTeams";
import NotFoundPage from "areas/not-found/NotFoundPage";
import ResultPage from "shared/components/ResultPage";
import ManageAppSettingsTable from "manage/app-settings/ManageAppSettings";
import ManageInvoiceTypes from "manage/invoice-types/ManageInvoiceTypes";
import InvoiceTypeDetailsPage from "manage/invoice-types/type-details/InvoiceTypeDetails";
import ManageInvoiceLineItems from "../manage/invoice-line-items/ManageInvoiceLineItems";
import ManageWorklogDefinitions from "../manage/worklog-definitions/ManageWorklogDefinitions";
import ManageEmpowerDepartment from "../manage/empower-departments/ManageEmpowerDepartment";

export const globalRoutes: RouteObject[] = [
  {
    // defining the path to make sure it will not redirect to Not Found page
    path: ROUTES.MAIN,
    // It will redirect if the user si part of a customer application
    // otherwise will show a message saying there no CA assigned
    // So is very unlikely for users to hit this page anymore but keep it as placeholder
    element: (
      <ResultPage title="Welcome" subTitle="RWS | Mercury" icon={false} />
    ),
  },
  {
    path: ROUTES.MANAGE_USERS,
    element: (
      <ProtectedRoute
        permissions={[
          {
            customerApplication: "Mercury",
            permissionName: "Users",
            action: "read",
          },
        ]}
      >
        <ManageUsers />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.MANAGE_USER_DETAILS,
    element: (
      <ProtectedRoute
        permissions={[
          {
            customerApplication: "Mercury",
            permissionName: "Users",
            action: "read",
          },
        ]}
      >
        <UserDetailsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.MANAGE_ROLES,
    element: (
      <ProtectedRoute
        permissions={[
          {
            customerApplication: "Mercury",
            permissionName: "Manage Roles",
            action: "read",
          },
        ]}
      >
        <ManageRoles />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.MANAGE_API_CLIENTS,
    element: (
      <ProtectedRoute
        permissions={[
          {
            customerApplication: "Mercury",
            permissionName: "Api Clients",
            action: "read",
          },
        ]}
      >
        <ManageApiClients />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.MANAGE_COST_CODES,
    element: (
      <ProtectedRoute
        permissions={[
          {
            customerApplication: "Google",
            permissionName: "Cost Code",
            action: "read",
          },
        ]}
      >
        <ManageCostCodes />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.MANAGE_INVOICE_TYPES,
    element: (
      <ProtectedRoute permissions={[
        {
          customerApplication: "Mercury",
          permissionName: "Invoice Types",
          action: "read",
        },
      ]}>
        {/* TODO should be without adminCheck and point to invoice types permission */}
        <ManageInvoiceTypes />
      </ProtectedRoute>
    ),
  },
  {
    path: `${ROUTES.MANAGE_INVOICE_TYPES}/:id`,
    element: (
      <ProtectedRoute permissions={[
        {
          customerApplication: "Mercury",
          permissionName: "Invoice Types",
          action: "read",
        },
      ]}>
        {/* TODO should be without adminCheck and point to invoice types permission */}
        <InvoiceTypeDetailsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.MANAGE_INVOICE_LINE_ITEMS,
    element: (
      <ProtectedRoute permissions={[
        {
          customerApplication: "Mercury",
          permissionName: "Invoice Line Items",
          action: "read",
        },
      ]}>
        <ManageInvoiceLineItems />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.MANAGE_WORKLOG_DEFINITIONS,
    element: (
      <ProtectedRoute permissions={[
        {
          customerApplication: "Mercury",
          permissionName: "Worklog Definitions",
          action: "read",
        },
      ]}>
        <ManageWorklogDefinitions />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.MANAGE_TEAMS,
    element: (
      <ProtectedRoute
        permissions={[
          {
            customerApplication: "Mercury",
            permissionName: "Manage Teams",
            action: "read",
          },
        ]}
      >
        <ManageTeamsTable />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.MANAGE_CURRENCIES,
    element: (
      <ProtectedRoute
        permissions={[
          {
            customerApplication: "Google",
            permissionName: "Currencies",
            action: "read",
          },
        ]}
      >
        <ManageCurrencies />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.MANAGE_HELIX_TEMPLATES,
    element: (
      <ProtectedRoute permissions={[READ_HELIX_TEMPLATES_PERMISSION]}>
        <ManageHelixTemplates />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.MANAGE_PO_TYPES,
    element: (
      <ProtectedRoute adminCheck customerApplication="Mercury">
        <ManagePOTypes />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.NOTIFICATIONS,
    element: <Notifications />,
  },
  {
    path: ROUTES.MANAGE_APP_SETTINGS,
    element: (
      <ProtectedRoute
        permissions={[
          {
            customerApplication: "Mercury",
            permissionName: "Settings",
            action: "read",
          },
        ]}
      >
        <ManageAppSettingsTable />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.MANAGE_EMPOWER_DEPARTMENT,
    element: (
      <ProtectedRoute permissions={[
          {
            customerApplication: "Google",
            permissionName: "Empower Departments",
            action: "read",
          },
        ]}>
        <ManageEmpowerDepartment />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.UNAUTHORIZED,
    element: (
      <Message
        first="Sorry"
        second="It appears you don't have access to this page, please contact support."
        loading={false}
      />
    ),
  },
  {
    path: ROUTES.NOT_FOUND,
    element: <NotFoundPage />,
  },
];
